module.exports = require("node:dns");